module.exports = __webpack_public_path__ + "img/高压泵.png";